import { render, staticRenderFns } from "./myanswer.vue?vue&type=template&id=1ea5bbe4&scoped=true&"
import script from "./myanswer.vue?vue&type=script&lang=ts&"
export * from "./myanswer.vue?vue&type=script&lang=ts&"
import style0 from "./myanswer.vue?vue&type=style&index=0&id=1ea5bbe4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ea5bbe4",
  null
  
)

export default component.exports